import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ApiResponse } from './api.types';

/**
 * Cliente único para la API v1.
 *
 * - Todas las operaciones son POST con el sobre `{ data }`.
 * - Desenvuelve la respuesta y entrega `response.data` directamente.
 * - NO atrapa el error: lo propaga para que el componente decida por
 *   `errorCode` (el `HttpErrorResponse.error` es el `ApiResponse`).
 * - El token (`Authorization: Bearer`) y `Content-Language` los añade
 *   `BearerAuthInterceptor`; aquí no se manejan.
 */
@Injectable({ providedIn: 'root' })
export class ApiService {
    private readonly base = `${environment.apiBaseUrl}/api/v1`;

    constructor(private http: HttpClient) {}

    post<T = any>(path: string, data: unknown = {}): Observable<T> {
        return this.http
            .post<ApiResponse<T>>(`${this.base}${path}`, { data })
            .pipe(map((res) => res.data as T));
    }

    /**
     * Para peticiones autenticadas que ocurren antes de persistir la sesión,
     * como las validaciones posteriores al login.
     */
    postWithToken<T = any>(
        path: string,
        data: unknown,
        token: string
    ): Observable<T> {
        const headers = new HttpHeaders({
            Authorization: `Bearer ${token}`,
        });
        return this.http
            .post<ApiResponse<T>>(`${this.base}${path}`, { data }, { headers })
            .pipe(map((res) => res.data as T));
    }

    /** Para endpoints que devuelven un archivo binario (PDF/XLSX). */
    postBlob(path: string, data: unknown = {}): Observable<Blob> {
        return this.http.post(`${this.base}${path}`, { data }, {
            responseType: 'blob',
        });
    }
}
